var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 44.4,
    viewBox: "0 0 64 44.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19246",
    "data-name": "Group 19246",
    transform: "translate(-1145 -2005.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit-file",
    d: "M43.012,9.324,41.148,7.448a4.7,4.7,0,0,0-6.671,0L33.3,8.625V4.34A4.356,4.356,0,0,0,28.949,0H14.641a1.129,1.129,0,0,0-.777.311L.333,13.486a1.137,1.137,0,0,0-.333.8V40.049A4.358,4.358,0,0,0,4.351,44.4h24.6A4.358,4.358,0,0,0,33.3,40.049V25.708L43.012,16a4.7,4.7,0,0,0,0-6.671ZM31.583,40.736c0,1.177-1.458,2.131-2.635,2.131H4.351c-1.177,0-2.7-.955-2.7-2.131V14.752L15.085,1.533H28.949c1.173,0,2.629.947,2.635,2.12v7.191l-8.906,8.392-.011.011-.022.022-3.763,3.763c-.011.022-.033.033-.044.056a.837.837,0,0,0-.089.122.461.461,0,0,0-.078.144.989.989,0,0,0-.089.255v.011L16.95,32.1a1.113,1.113,0,0,0,1.088,1.321,1.221,1.221,0,0,0,.2-.022l8.6-1.51a.022.022,0,0,0,.022-.011,1.33,1.33,0,0,0,.366-.133.444.444,0,0,0,.133-.111.543.543,0,0,0,.144-.133l4.078-3.574ZM21.075,23.565l2.22-2.22,6.131,6.068-2.209,2.22-6.142-6.068Zm3.785,6.968-6.279,1.1,1.4-5.927,4.877,4.826Zm9.006-7.548-2.22,2.22-.655.644L24.86,19.78l8.891-8.891,6.131,6.068Zm7.706-7.457c-1.419-1.3-6.255-6.2-6.255-6.2l.566-.566c1.133-1.4,2.433-.989,3.689.255l1.876,1.876c1.635,1.5,2.112,2.489.812,3.889A8.308,8.308,0,0,1,41.572,15.528Z",
    transform: "translate(1159.8 2005.8)",
    fill: "#6b6b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edit-file-2",
    "data-name": "edit-file",
    d: "M15.919,5.363c-.613,0-.834.537-.834,1.15v8.24H6.868c-.613,0-1.049.273-1.049.886s.436.865,1.049.865h8.88a1.11,1.11,0,0,0,1.11-1.11V6.512c0-.613-.326-1.15-.939-1.15Z",
    transform: "translate(1160.142 2005.8)",
    fill: "#a7a7a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19245",
    "data-name": "Group 19245",
    transform: "translate(2.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9770",
    "data-name": "Rectangle 9770",
    width: 51,
    height: 1.5,
    rx: 0.75,
    transform: "translate(1149 2048.7)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19243",
    "data-name": "Group 19243",
    transform: "translate(0 139.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9771",
    "data-name": "Rectangle 9771",
    width: 3,
    height: 1.5,
    rx: 0.75,
    transform: "translate(1201 1909)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9772",
    "data-name": "Rectangle 9772",
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(1205 1909)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19244",
    "data-name": "Group 19244",
    transform: "translate(1142.5 2048.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9771-2",
    "data-name": "Rectangle 9771",
    width: 3,
    height: 1.5,
    rx: 0.75,
    transform: "translate(2.5)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9772-2",
    "data-name": "Rectangle 9772",
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "#a7a7a7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19250",
    "data-name": "Group 19250",
    transform: "translate(1151.705 2027.842)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2889",
    "data-name": "Ellipse 2889",
    cx: 1.331,
    cy: 1.331,
    r: 1.331,
    transform: "translate(0 -14.014)",
    fill: "#eb1000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 0.799,
    cy: 0.799,
    r: 0.799,
    transform: "translate(50.262 -19.338)",
    fill: "#eb1000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 0.799,
    cy: 0.799,
    r: 0.799,
    transform: "translate(6.389 -19.338)",
    fill: "#eb1000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.83e6ab98e7d301e388f4182ec3a81f9c.svg";
export { ForwardRef as ReactComponent };